import { useScopedSelector } from 'ia-react-core';
import React, { FC, useState } from 'react';
import { SecurityQuestions } from '../../interfaces/SecurityQuestions';
import { SecurityQuestionsResourceInfo } from '../SecurityQuestionsResource/SecurityQuestionsResource';
import SecurityQuestionControl from './SecurityQuestionControl';
import { SecurityQuestion } from '../../interfaces/SecurityQuestion';

export interface SecurityQuestionsSectionProps {
  currentSecurityQuestions: SecurityQuestion[];
}

const SecurityQuestionsSection: FC<SecurityQuestionsSectionProps> = ({ currentSecurityQuestions }) => {
  const securityQuestions: SecurityQuestions = useScopedSelector(SecurityQuestionsResourceInfo.dataDst);
  const alreadySelectedAnswers = currentSecurityQuestions.map((x) => x.answer);
  while (alreadySelectedAnswers.length < securityQuestions.behaviours.numberOfQuestions) {
    alreadySelectedAnswers.push(undefined);
  }
  const alreadySelectedQuestions = currentSecurityQuestions.map((x) => x.code);
  while (alreadySelectedQuestions.length < securityQuestions.behaviours.numberOfQuestions) {
    alreadySelectedQuestions.push(undefined);
  }
  const [selectedAnswers, setSelectedAnswers] = useState(alreadySelectedAnswers);
  const [selectedQuestions, setSelectedQuestions] = useState(alreadySelectedQuestions);

  const onAnswerChange = (questionNumber: number) => (value: string) =>
    setSelectedAnswers((prev) => prev.map((x, i) => i === questionNumber - 1 ? value : x));

  const onQuestionChange = (questionNumber: number) => (value: string) =>
    setSelectedQuestions((prev) => prev.map((x, i) => i === questionNumber - 1 ? value : x));

  const questionControls = [] as JSX.Element[];
  for (let i = 1; i < securityQuestions.behaviours.numberOfQuestions + 1; i++) {
    questionControls.push((<SecurityQuestionControl
      key={i}
      questionNumber={i}
      selectedAnswers={selectedAnswers}
      selectedQuestions={selectedQuestions}
      onAnswerChange={onAnswerChange(i)}
      onQuestionChange={onQuestionChange(i)}
    />));
  }
  return (
    <>
      {questionControls}
    </>
  );
};

export default SecurityQuestionsSection;
